// ETag cache for cheap 304 revalidation on C2/C3 reads (API-32). Registries and
// public listing reads carry an ETag; on the next request the client sends
// `If-None-Match` and, on a 304, replays the cached body — headers-only cost.
// In-memory, bounded (simple LRU by insertion order). No Node APIs.

export interface EtagEntry {
  etag: string;
  body: unknown;
}

export interface EtagCache {
  get(key: string): EtagEntry | undefined;
  set(key: string, entry: EtagEntry): void;
  delete(key: string): void;
  clear(): void;
}

export function createEtagCache(maxEntries = 200): EtagCache {
  const store = new Map<string, EtagEntry>();

  return {
    get(key) {
      const entry = store.get(key);
      if (entry) {
        // Refresh recency: re-insert so eviction drops the least-recently-used.
        store.delete(key);
        store.set(key, entry);
      }
      return entry;
    },
    set(key, entry) {
      if (store.has(key)) store.delete(key);
      store.set(key, entry);
      while (store.size > maxEntries) {
        const oldest = store.keys().next().value;
        if (oldest === undefined) break;
        store.delete(oldest);
      }
    },
    delete(key) {
      store.delete(key);
    },
    clear() {
      store.clear();
    },
  };
}
